import { render } from "./TagColor.vue?vue&type=template&id=e89a7b7e&scoped=true"
import script from "./TagColor.vue?vue&type=script&lang=js"
export * from "./TagColor.vue?vue&type=script&lang=js"

import "./TagColor.vue?vue&type=style&index=0&id=e89a7b7e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e89a7b7e"]])

export default __exports__